import { IconButton } from "@circleco/compass/components/IconButton";
import { Tooltip } from "@circleco/compass/components/Tooltip";
import type { ComponentPropsWithoutRef } from "react";

interface ConversationCloseIconButtonProps {
  "aria-controls"?: string;
  "data-testid"?: string;
  icon: ComponentPropsWithoutRef<typeof IconButton>["icon"];
  label: string;
  onClose: () => void;
}

export const ConversationCloseIconButton = ({
  "aria-controls": ariaControls,
  "data-testid": testId,
  icon,
  label,
  onClose,
}: ConversationCloseIconButtonProps) => (
  <Tooltip content={label} side="bottom">
    <IconButton
      data-testid={testId}
      onClick={onClose}
      icon={icon}
      variant="ghost"
      size="sm"
      aria-label={label}
      aria-controls={ariaControls}
    />
  </Tooltip>
);
